module.exports = __webpack_public_path__ + "media/images/bg-masthead-f16c2ada8769e989244cd09f67a76b14.jpg";